<template>
	<div class="navZcy">
		<el-dialog title="提交app信息" :visible.sync="dialogVisible" width="500px" :close="handleClose" top="8vh">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">*</span>上传apk：</dt>
						  <!--:http-request="hashMd5"
						  :data="fileData"-->
					<dd>
						<el-upload
						  class="upload-demo"
						  ref="upload"
						  :action="'zcvrVideoApi/appMsg/uploadApk/'+session"
						  :before-upload="beforeAvatarUpload"
						  :on-remove="handleRemove"
						  :file-list="fileList"
						  :on-success="uploadSuccess"
						  :on-error="uploadError"
						  :on-change="handleChange"
						  :limit="2"
						  :auto-upload="false">
						  <!--<el-button size="small" type="primary">上传视频</el-button>-->
						  <el-button slot="trigger" size="small" type="primary">选取apk文件</el-button>
  						 <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传apk文件</el-button>
						  <span slot="tip" class="el-upload__tip tooltip">只能上传apk文件</span>
						</el-upload>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>版本号：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.version" placeholder="版本号"></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()":loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<router-link to="/videoManager">
			<el-button size="medium" type="success" :class="num==1?'':'is-plain'">视频管理</el-button>
		</router-link>
		<router-link to="/imageManager">
			<el-button size="medium" type="success" :class="num==2?'':'is-plain'">图集管理</el-button>
		</router-link>
		<router-link to="/machineManager">
			<el-button size="medium" type="success" :class="num==3?'':'is-plain'">机台管理</el-button>
		</router-link>
		<router-link to="/systemManager">
			<el-button size="medium" type="success" :class="num==4?'':'is-plain'">系统管理</el-button>
		</router-link>
		<!--<router-link to="/machineinfo">
			<el-button size="medium" type="success" :class="num==6?'':'is-plain'">机台信息管理</el-button>
		</router-link>
		<router-link to="/room">
			<el-button size="medium" type="success" :class="num==7?'':'is-plain'">空间管理</el-button>
		</router-link>
		<router-link to="/series">
			<el-button size="medium" type="success" :class="num==8?'':'is-plain'">系列管理</el-button>
		</router-link>
		<router-link to="/seriesGroup">
			<el-button size="medium" type="success" :class="num==9?'':'is-plain'">系列分组管理</el-button>
		</router-link>
		<el-button size="medium" type="success" class="is-plain" @click="sumbitAppMsg">APP</el-button>-->
	</div>
</template>

<script>
	export default{
		props: ['num'],
		data() {
			return {
				loading: false,
				dialogVisible: false,
				fileList: [],
				dialogData: {},
				session: ""
			}
		},
		methods: {
			beforeAvatarUpload(file) {
				console.log(file.name.split('.'))
				var name = file.name.split('.')
		        const isMP4 = name[name.length-1] === 'apk';

		        if (!isMP4) {
		          this.$message.error('上传文件只能是 apk格式!');
		        }
//		        this.hashMd5(file)
		        return isMP4;
		    },
		    submitUpload() {
//		    	console.log(this.fileList)
		    	$('.el-upload-list').css('height',"29px")
		    	this.$refs.upload.submit();
		    },
		    uploadSuccess(response, file, fileList) {
//		    	console.log(response)
				if(response.msg=="ok"){
					this.dialogData.url = response.data.url
					this.dialogData.md5 = response.data.md5
					var pakUrlName = this.dialogData.url.split("/")
				    this.fileList = [{
				    	name: pakUrlName[pakUrlName.length-1]
				    }]
				}else{
					this.$message({
						type: 'error',
						message: response.msg
					});
					if(response.msg=="该SessionId已经超时"){
			  			this.$message.error("登录超时！请重新登录");
			  			this.$router.push({path: '/',query: ''})
			  		}
				}
		    },
		    handleChange(files, fileList){
//		    	console.log(fileList)
		    	this.fileList=[]
		    	this.fileList.push(fileList[fileList.length-1])
		    },
			handleRemove(file, fileList){
				$('.el-upload-list').css('height','auto')
				this.dialogData.url = ""
			},
		    uploadError(err, file, fileList) {
		    	this.$router.push({path: '/',query: ''})
		    },
			sumbitAppMsg() {
				this.getAppMsg()
				this.dialogVisible = true
				var vue = this
				setTimeout(function(){
					$("a.el-upload-list__item-name").attr("href",vue.dialogData.url)
				},300)
			},
			handleClose: function(done) {
				done();
			},
			getAppMsg() {
				this.$http.get("zcvrVideoApi/appMsg/inquiryApp",{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
		  				if(success.body.msg!="ok"){
		  					this.fileList = []
		  					this.dialogData = {}
							if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}else {
		  					if(success.body.data) {
		  						this.dialogData = success.body.data
		  						if(this.dialogData.url){
		  							var pakUrlName = this.dialogData.url.split("/")
								    this.fileList = [{
								    	name: this.dialogData.url
								    }]
		  						}
		  					}else{
		  						this.fileList = []
		  						this.dialogData = {}
		  					}
		  				}

		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			handleConfirm() {
				var url = ""
				var pakUrl = this.dialogData.url
				if(pakUrl){
					if(pakUrl.indexOf("http") != -1){
						var pakUrl = pakUrl.split("/")
						pakUrl = pakUrl[pakUrl.length-2]+"/"+pakUrl[pakUrl.length-1]
					}
				}else{
					this.$message.error("请上传apk文件");
					return
				}
				var data = {
					version: this.dialogData.version,
					md5: this.dialogData.md5,
					url: pakUrl
				}
				this.$http.post('zcvrVideoApi/appMsg/updateApp/'+this.session,data,{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
						this.loading=false
		  				if(success.data.msg=="ok"){
		  					this.dialogVisible = false
		  					this.getAppMsg()
		  				}else {
		  					this.$message({
					          message: success.data.msg,
					          type: 'error'
					        });
			  				if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}
		  			},
		  			(error)=>{
						this.loading=false
						this.$message.error("数据连接失败");
		  			}
		  		)
			}
		},
		mounted(){
			this.session = sessionStorage.getItem('sessionId')
		}
	}
</script>

<style scoped>
	.navZcy{
		padding-left: 20px;
		background: #eee;
		line-height: 60px;
	}
	.navZcy a{
		margin-right: 10px;
		text-decoration: none;
		color: #000;
	}
	.checktip{
		color: red;
	}
</style>
